import apiClient from './apiClient';

export const createContract = async (title, pages) => {
  try {
    const response = await apiClient.post('/contracts', { title, pages });
    return response.data;
  } catch (error) {
    console.error('Error creating contract:', error);
    throw error;
  }
};

export const deleteProposal = async (emailId) => {
  try {
    await apiClient.delete(`/proposal/${emailId}`);
  } catch (error) {
    throw new Error(`Failed to delete proposal with ID ${emailId}: ${error.message}`);
  }
};
